import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function ZapIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M5.90939 16.0051C5.90939 11.7726 8.52933 8.14094 12.2323 6.64537L14.1218 2.8501C7.68064 3.76516 2.71093 9.31517 2.71093 16.0051C2.71093 22.0916 6.82465 27.2351 12.4175 28.8025L12.781 25.5687C8.79059 24.2223 5.90939 20.4439 5.90939 16.0051Z"
        fill="currentColor"
      />
      <path
        d="M29.2854 16.0052C29.2854 9.91995 25.1734 4.77742 19.5825 3.20899L19.2108 6.44043C23.2035 7.78548 26.0869 11.5649 26.0869 16.0052C26.0869 20.2132 23.4975 23.827 19.8286 25.3387L17.8867 29.1586C24.3219 28.2383 29.2854 22.6909 29.2854 16.0052Z"
        fill="currentColor"
      />
      <path
        d="M23.6053 14.395C23.7313 14.1472 23.7195 13.8751 23.574 13.6382C23.4286 13.4012 23.1706 13.3068 22.8925 13.3068H16.8133L18.1221 1.92955C18.1666 1.54384 17.9275 1.14423 17.5551 1.03368C17.4783 1.01089 17.4004 1 17.3235 1C17.0283 1 16.7491 1.16802 16.6117 1.44398L8.39041 17.9637C8.26707 18.2115 8.28066 18.5413 8.4264 18.7768C8.57223 19.0122 8.8293 19.2038 9.10626 19.2038H15.1053L13.8755 30.153C13.8325 30.5371 14.0705 30.8602 14.4409 30.971C14.517 30.9938 14.594 31 14.6701 31C14.9647 31 15.2438 30.8363 15.383 30.5624L23.6053 14.395Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
